export const expandableCollapsedDefaultHeight = 100;
export const expandableDefaultAnimationTime = 300;
export const expandableCollapsedDefaultHeight = 100;
export const expandableDefaultAnimationTime = 300;
